import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';

@withSizes(({ width }) => ({
    isHandheld: width < 980
}))
export default class Video extends React.Component {
    static propTypes = {
        autoPlay: PropTypes.bool,
        isHandheld: PropTypes.bool.isRequired,
        poster: PropTypes.string,
        loop: PropTypes.bool,
        soundControls: PropTypes.bool,
        assets: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.string.isRequired,
                src: PropTypes.string.isRequired
            }).isRequired
        ).isRequired,
        styles: PropTypes.object
    };
    static defaultProps = {
        styles: {},
        autoPlay: false,
        loop: false,
        poster: null,
        soundControls: false
    };

    state = {
        destroy: false,
        muted: true,
    };
    refs = {};
    muteControlsTransitionTimeout;

    componentDidMount = () => {
        this.checkAutoPlay(this.props);
    }

    componentWillReceiveProps = nextProps => {
        this.checkAutoPlay(nextProps);

        if (JSON.stringify(this.props.assets) !== JSON.stringify(nextProps.assets)) {
            this.setState(prevState => ({
                ...prevState,
                destroy: true
            }));

            setTimeout(() => {
                this.setState(prevState => ({
                    ...prevState,
                    destroy: false
                }));
            }, 50);
        }
    }

    checkAutoPlay = props => {
        const { autoPlay } = props;

        if (autoPlay) {
            this.refs.videoPlayer.autoplay = true;
            this.refs.videoPlayer.play();
        }
    }

    showSoundControls = e => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            muteControlsTransition: true,
        });

        clearTimeout(this.muteControlsTransitionTimeout);
        this.muteControlsTransitionTimeout = setTimeout(() => {
            this.setState({
                muteControlsTransition: false,
            });
        }, 2000);
    }

    toggleMute = e => {
        e.preventDefault();
        e.stopPropagation();

        this.refs.videoPlayer.play();
        this.setState(prevState => ({
            muted: !prevState.muted,
        }));        
    }

    render() {
        const { destroy, muted, muteControlsTransition } = this.state;
        const { poster, loop, assets, autoPlay, styles, soundControls, isHandheld } = this.props;
        if (destroy) return null;

        return (
            <div  className="component-video">
                <div 
                    className="video-mask" 
                    onClick={e => soundControls && this.showSoundControls(e)}
                >
                    {soundControls &&
                        <div
                            className={`sound-controls ${muteControlsTransition ? 'visible' : ''}`}
                            onClick={e => soundControls && this.toggleMute(e)}
                        >
                            {muted ?
                                <div className="sound-control">
                                    <i className="fa fa-volume-up"></i>
                                </div>
                                :
                                <div className="sound-control">
                                    <i className="fa fa-volume-down"></i>
                                </div>
                            }
                            </div>
                        }
                        <video
                            autoPlay={autoPlay}
                            ref="videoPlayer"
                            width="100%"
                            loop={isHandheld ? false : loop}
                            muted={muted}
                            preload="auto"
                            onClick={e => e.target.play()}
                            poster={poster}
                            controlsList="nodownload"
                            style={styles}
                            playsInline
                        >
                        {assets.map(asset => (<source key={asset.src} src={asset.src} type={asset.type} />))}
                    </video>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Video/index.js